import Vue from 'vue'
import '@/plugins'
import App from './App.vue'
import router from './router'
import store from './store'
import './components/global'
import './registerServiceWorker'
import 'intersection-observer'
import { sync } from 'vuex-router-sync'
require(`@/themes/${process.env.VUE_APP_THEME}/global.css`)

sync(store, router)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render : h => h(App)
}).$mount('#app')
